module.exports = __webpack_public_path__ + "img/tank-base-shadow-4.1c68194b.png";